document.addEventListener('DOMContentLoaded',  function() {
    const menu_bar = document.querySelector(".top-level-links-container");
    const mega_menu_images = menu_bar.querySelectorAll("img");

    menu_bar.addEventListener("mouseover", () => {
        if (!menu_bar.classList.contains("mega-menu-images-loaded")) {
            menu_bar.classList.add("mega-menu-images-loaded");
            mega_menu_images.forEach(img => {
                let data_src = img.getAttribute("data-src");
                img.setAttribute("src",data_src);
            })
        }
    })
})